// extracted by mini-css-extract-plugin
module.exports = {"scheduleGridWrapper":"Schedule_scheduleGridWrapper__JVjnD","tournamentOverviewLayout":"Schedule_tournamentOverviewLayout__iekio"};